import React from 'react';
import './ProcessSection.css';

const steps = [
  {
    num: '1',
    title: 'Choose a Service',
    desc: 'Select the tax service that fits your needs — individual, business, or special services. Not sure? We\'ll help you decide.',
    icon: '🎯',
  },
  {
    num: '2',
    title: 'Request a Meeting',
    desc: 'Book a free consultation by phone, WhatsApp, or email. We\'ll review your situation and gather what\'s needed.',
    icon: '📅',
  },
  {
    num: '3',
    title: 'Receive Custom Plan',
    desc: 'We securely collect your documents and prepare your return, identifying every deduction to maximize your refund.',
    icon: '📋',
  },
  {
    num: '4',
    title: "Let's Make It Happen",
    desc: 'Your return is e-filed within 24–48 hours. Sit back and wait for your maximum refund to arrive.',
    icon: '🚀',
  },
];

const ProcessSection = () => (
  <section className="section" id="process">
    <div className="container">
      <div className="section-header">
        <div className="section-label">How It Works</div>
        <h2 className="section-title">
          Check Out Our <em>Work Process</em>
        </h2>
        <p className="section-subtitle">
          Getting your taxes filed is simple, fast, and 100% remote.
          Here's how we do it in just four easy steps.
        </p>
      </div>
      <div className="process-grid">
        {steps.map((step, i) => (
          <div className="process-step" key={step.num}>
            <div className="process-connector" style={{ opacity: i < steps.length - 1 ? 1 : 0 }} />
            <div className="step-circle">
              <span className="step-num">{step.num}</span>
              <span className="step-icon">{step.icon}</span>
            </div>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSection;
